/**
 * @flow
 */

import React from 'react';
import styled from 'styled-components';
import { Input as BaseInput, Icon } from 'semantic-ui-react';

const Input = styled(BaseInput)`
    &.disabled {
        &,
        input:disabled,
        .disabled {
            opacity: 1 !important;
            background-color: #fffaf3;
        }
    }
`;

type EmailFieldProps = {
    userLookupStatus: string,
    disabled?: boolean,
};

const EmailField = ({
    userLookupStatus,
    disabled,
    ...props
}: EmailFieldProps) => (
    <Input
        {...props}
        className={disabled ? 'disabled' : ''}
        disabled={disabled}
        icon={
            userLookupStatus === 'EXISTS' && (
                <Icon name="checkmark" color="green" inverted circular />
            )
        }
        loading={userLookupStatus === 'CHECKING'}
    />
);

export default EmailField;
